import type { TrackedClickableElementName } from '@savvy/deprecated-shared/tracking/tracked-clickable-element-name';

import TrackedButton from '../tracked/tracked-button';

export default function ItemDialogYesNoButtons({
  yesButtonElementName,
  noButtonElementName,
  value,
  onClick,
}: {
  readonly yesButtonElementName: TrackedClickableElementName;
  readonly noButtonElementName: TrackedClickableElementName;
  readonly value?: string;
  readonly onClick: (value: boolean) => void;
}) {
  return (
    <div className="flex flex-row gap-2">
      <TrackedButton
        elementName={yesButtonElementName}
        variant="secondary"
        className={value === 'true' ? 'bg-component-hover' : undefined}
        onClick={() => {
          onClick(true);
        }}
      >
        Yes
      </TrackedButton>
      <TrackedButton
        elementName={noButtonElementName}
        variant="secondary"
        className={value === 'false' ? 'bg-component-hover' : undefined}
        onClick={() => {
          onClick(false);
        }}
      >
        No
      </TrackedButton>
    </div>
  );
}
